import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { URL, ExternalLink } from 'shared';
function WizardFooter() {
    return (_jsxs("footer", { children: [_jsx("div", { className: "footer-container", children: _jsx(ExternalLink, { href: URL.PATIENT_SUPPORT, children: _jsx("span", { children: "PATIENT SUPPORT" }) }) }), _jsxs("div", { className: "copyright", children: ["Copyright @ ", new Date().getFullYear(), " Alphaeon Credit. All rights reserved."] })] }));
}
export default memo(WizardFooter);
